import { useSyncExternalStore } from 'react';

/** Uygulama geneli katmanlar: palet, premium, kısayollar, toast. */
type UiState = {
  palette: boolean;
  premium: null | { reason?: string };
  shortcuts: boolean;
  toasts: { id: number; text: string }[];
};

let state: UiState = { palette: false, premium: null, shortcuts: false, toasts: [] };
const listeners = new Set<() => void>();
let nextId = 1;

function set(patch: Partial<UiState>) {
  state = { ...state, ...patch };
  listeners.forEach((l) => l());
}

export function useUi(): UiState {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => state
  );
}

export const ui = {
  openPalette: () => set({ palette: true }),
  closePalette: () => set({ palette: false }),
  openPremium: (reason?: string) => set({ premium: { reason } }),
  closePremium: () => set({ premium: null }),
  openShortcuts: () => set({ shortcuts: true }),
  closeShortcuts: () => set({ shortcuts: false }),
  toast(text: string) {
    const id = nextId++;
    set({ toasts: [...state.toasts, { id, text }] });
    setTimeout(() => set({ toasts: state.toasts.filter((t) => t.id !== id) }), 2800);
  },
};
